export default "<div id=\"surveyReorderContainer\"></div>\n<div id=\"surveyReorderResult\"></div>";